/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Wrapper for Asset field, list of fields is defined when media center is created.
 * @export
 * @interface AssetField
 */
export interface AssetField {
    /**
     * Field name
     * @type {string}
     * @memberof AssetField
     */
    name: string;
    /**
     * Field values
     * @type {object}
     * @memberof AssetField
     */
    value: object;
}

export function AssetFieldFromJSON(json: any): AssetField {
    return AssetFieldFromJSONTyped(json, false);
}

export function AssetFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function AssetFieldToJSON(value?: AssetField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

